export default {"src":"/_next/static/image/public/images/ic_close_black.44f6af8933263efed73ab2af6012f8c5.svg","height":24,"width":24};